import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBodyText, FDImage, FDStack,
} from '@facet-wealth/design';

const MemberResponse = ({ resource }) => {
  const isTextResponse = resource.isTruthy('isText');
  return (
    <FDStack direction={isTextResponse ? 'column' : 'row'} spacing={isTextResponse ? 0 : 1} alignItems={!isTextResponse ? 'center' : 'flex-start'}>
      <FDBodyText size={'sm'} color="textDisabled" value={resource.meta().field('response').attr('prompt')} />
      { isTextResponse
        ? <FDBodyText value={resource.attr('response')} />
        : <FDImage src={resource.attr('response')} alt={'Member image response'} maxWidth={'50px'} />
      }
    </FDStack>
  );
};

MemberResponse.defaultProps = {
};

MemberResponse.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default MemberResponse;
